import { render, staticRenderFns } from "./specificFieldDetail.vue?vue&type=template&id=65d39b3e&scoped=true&"
import script from "./specificFieldDetail.vue?vue&type=script&lang=js&"
export * from "./specificFieldDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d39b3e",
  null
  
)

export default component.exports